import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

//import { Button, ButtonGroup } from 'reactstrap';
import CharacteristicsLoading from './CharacteristicsLoading';
import DesignLoading from './DesignLoading';
import { loadsTabModes } from '@reducers/selectors/loads/loadsTabModes';
import './styles.scss';
import './../../../index.scss';
import { setLoadsTabMode, setImportState } from '@reducers/selectors/loads/actions';
import { APP_TYPES, BRAND } from '@config';
import { brandList, standardList } from './../../../app.values';
import { APP_TEXTS } from '../../../texts/texts';
import { Tooltip } from '@components/Tippy';
import { APP_TOOLTIPS } from '../../../../src/texts/tooltips';
import { isICCorCSA } from '@services/helper.service';
import { allowEditLoads } from '@reducers/options/actions';

class GeneralLoading extends Component {

  static propTypes = {
    loadsTabMode: PropTypes.string.isRequired,
    setLoadsTabMode: PropTypes.func.isRequired
  };

  render() {
    return (
      <div className="calculation design-and-combined-loading">
          <section className="list-type">
            <div className={`btn-group ${isICCorCSA(Number(this.props.designStd)) || 
                (Number(this.props.designStd) === standardList["Masonry"] && BRAND === brandList.Redhead) && 'w-50'}`}>
              <Tooltip content={APP_TOOLTIPS.TOOLTIP_DESIGN_LOADING_BUTTON.Content}>
                <button
                  className={`btn ${this.props.loadsTabMode === loadsTabModes.DESIGN && 'ToggleButton--active'}`}
                  name="design"
                  onClick={() => this.switchLoading(loadsTabModes.DESIGN)}>
                {APP_TEXTS.DESIGN_LOADING.Content}
                </button>
              </Tooltip>

                {!isICCorCSA(Number(this.props.designStd)) && 
                (Number(this.props.designStd) !== standardList["Masonry"] || BRAND !== brandList.Redhead) && (
                  <Tooltip content={APP_TOOLTIPS.TOOLTIP_CALCULATE_DESIGN_LOAD_BUTTON.Content}>
                    <button
                      className={`btn ${this.props.loadsTabMode === loadsTabModes.CHARACTERISTICS && 'ToggleButton--active'}`}
                      name="combined"
                      onClick={() => this.switchLoading(loadsTabModes.CHARACTERISTICS)}>
                      {APP_TEXTS.CALCULATE_DESIGN_LOAD.Content}
                    </button>
                  </Tooltip>
                )}
            </div>
          </section>

        {this.props.loadsTabMode === loadsTabModes.DESIGN ? (
          <div className="calculation">
            <section className="list-type">
              { BRAND === brandList.Ramset && Number(this.props.designStd) === standardList["Masonry"] ? (
                <React.Fragment>
                  <span className="loading-description">
                    {APP_TEXTS.DESIGN_LOADS_RAMSET_MASONRY.Content}
                  </span>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <span className="loading-description">
                    {APP_TEXTS.DESIGN_LOADS_INCLUDING_PARTIAL_FACTOR.Content}
                  </span>
                  { (BRAND === brandList.Ramset && 
                  Number(this.props.designStd) !== standardList['EU'] && Number(this.props.designStd) !== standardList['AS5216']) ? (
                    <span className="loading-description">
                      <br />
                      {APP_TEXTS.EU_METHOD_FOR_SEISMIC_AND_FIRE_DESIGN.Content}
                    </span>
                  ) : (Number(this.props.designStd) === standardList['AnnexC']) && (
                    <span className="loading-description">
                      <br />
                      {APP_TEXTS.EN1992_METHOD_FOR_SEISMIC_AND_FIRE_DESIGN.Content}
                    </span>
                  )}
                </React.Fragment>
              )}
              
              <DesignLoading />
            </section>
          </div>
        ) : (
          <CharacteristicsLoading />
        )}
      </div>
    );
  }

  switchLoading = (loadsTabMode) => {
    if (loadsTabMode !== this.props.loadsTabMode) {
      this.props.setLoadsTabMode(loadsTabMode);
      this.props.allowEditLoads(loadsTabMode === loadsTabModes.DESIGN);
      if (loadsTabMode === loadsTabModes.CHARACTERISTICS && this.props.isImporting)
        this.props.setImportState(false);
    }
  };

}

const mapState = state => ({
  loadsTabMode: state.selectors.loads[APP_TYPES.GENERAL_CALCULATION].loadsTabMode,
  designStd: state.main.localization.designStandard,
  isImporting: state.selectors.loads[state.main.appType].importState.isImporting,
  appStatus: state.main.status // use it as a hack to render a potential language change
});

const mapDispatch = dispatch => ({
  setLoadsTabMode: mode => dispatch(setLoadsTabMode(mode)),
  allowEditLoads: value => dispatch(allowEditLoads(value)),
  setImportState: (value) => dispatch(setImportState(value))
});

export default connect(mapState, mapDispatch)(GeneralLoading);



// WEBPACK FOOTER //
// ./src/views/Loads/GeneralLoading/index.js